module.exports = __webpack_public_path__ + "img/coin_in_hand.66b76056.png";